import { sciIconModePostfix } from "@/const";

export function darkModeReplacePostfix(str: string, darkMode: boolean): string {
  if (Object.values(sciIconModePostfix).every(i => !str.includes(i))) return "";

  const replacer = darkMode ? sciIconModePostfix.LIGHT : sciIconModePostfix.DARK;
  const postfix = darkMode ? sciIconModePostfix.DARK : sciIconModePostfix.LIGHT;
  return str.replace(postfix, replacer);
}
